import { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableComponent from "@mui/material/Table";

const vacationTable = [];

const tableHeaders = [
  { id: "FullName", label: "Фамилия Имя Отчество", minWidth: 70 },
  { id: "Section", label: "Отделение", minWidth: 70 },
  { id: "WorkPosition", label: "Должность", minWidth: 70 },
  { id: "WorkType", label: "Вид работы", minWidth: 70 },
  { id: "Personal", label: "Персонал", minWidth: 70 },
  { id: "M1", label: "М1", minWidth: 70 },
  { id: "D1", label: "Д1", minWidth: 70 },
  { id: "O1", label: "О1", minWidth: 70 },
  { id: "M2", label: "М2", minWidth: 70 },
  { id: "D2", label: "Д2", minWidth: 70 },
  { id: "O2", label: "О2", minWidth: 70 },
  { id: "M3", label: "М3", minWidth: 70 },
  { id: "D3", label: "Д3", minWidth: 70 },
  { id: "O3", label: "О3", minWidth: 70 },
  { id: "M4", label: "М4", minWidth: 70 },
  { id: "D4", label: "Д4", minWidth: 70 },
  { id: "O4", label: "О4", minWidth: 70 },
  { id: "M5", label: "М5", minWidth: 70 },
  { id: "D5", label: "Д5", minWidth: 70 },
  { id: "O5", label: "О5", minWidth: 70 },
];

const VacationSchedule: FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1.5}
      justifyContent="space-between"
      width='90vw'
      height='80vh'
    >
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography>Отчетный год</Typography>
            <TextField variant="outlined" size="small" sx={{ width: "70px" }} />
          </Box>
          <Box sx={{ width: 200 }}>
            <FormControl fullWidth>
              <InputLabel>По всему персоналу</InputLabel>
              <Select value="" size="small">
                <MenuItem value={10}>Вариант 1</MenuItem>
                <MenuItem value={20}>Вариант 2</MenuItem>
                <MenuItem value={30}>Вариант 3</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography>Месяц с</Typography>
            <Select value="" size="small">
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
            </Select>
            <Typography>по</Typography>
            <Select value="" size="small">
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
            </Select>
            <Button variant="contained" size="small">
              Извещения
            </Button>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Button variant="contained" size="small">
              Не использован отпуск
            </Button>
            <Button variant="contained" size="small">
              По подразделениям
            </Button>
          </Box>
        </Box>
      </Box>
      <Box>
        <Tooltip title="добавить новую запись о сотруднике (модалка)">
          <IconButton>1</IconButton>
        </Tooltip>
        <Tooltip title="Удалить запись">
          <IconButton>2</IconButton>
        </Tooltip>
        <Tooltip title="Удалить все записи за отчетный год">
          <IconButton>3</IconButton>
        </Tooltip>
        <Tooltip title="Формирование списка сотрудников на новый отчетный год">
          <IconButton>4</IconButton>
        </Tooltip>
        <Tooltip title="Поиск на форме (модалка)">
          <IconButton>5</IconButton>
        </Tooltip>
        <Tooltip title="Выход из формы">
          <IconButton>6</IconButton>
        </Tooltip>
      </Box>
      <Box display='flex' overflow='auto'>
        <TableContainer>
          <TableComponent stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {tableHeaders.map((column) => (
                  <TableCell key={column.id} size="small" sx={{fontSize: '10px', textWrap: 'nowrap'}} >
                    <b>{column.label}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {["", "", "", "", "", "", "", "", "", "", "", "", "", "", ""].map(
                (item, id) => {
                  return (
                    <TableRow hover tabIndex={-1} key={id}>
                      {tableHeaders.map((column) => (
                        <TableCell key={column.id}>
                          {item}
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                }
              )}
            </TableBody>
          </TableComponent>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default VacationSchedule;
